import React from "react";
import Footer from "../../components/footer/Footer";
import Newsletter from "../../components/newsletter/Newsletter";
import {
  PrivacyPageContainer,
  PrivacyPageTable,
  PrivacyPageTitle,
  PrivacyResultCard,
} from "./PrivacyStyles";

function Privacy() {
  return (
    <PrivacyPageContainer>
      <PrivacyPageTable>
        <PrivacyPageTitle>Privacy en Cookie Policy</PrivacyPageTitle>
        <PrivacyResultCard>
          Het vertrouwen dat wij zorgvuldig omgaan met jouw persoonsgegevens
          willen we elke dag weer waarmaken. We werken met goed beveiligde
          informatiesystemen en heldere privacy statements. Wanneer nodig passen
          we deze aan. Zoals nu, met de invoering van de Algemene Verordening
          Gegevensverwerking (AVG). Lees hier hoe wij omgaan met jouw
          persoonsgegevens.
          <br />
          <b>Wie zijn we?</b>
          Smart-Personeel B.V. is gevestigd te Nijmegen, en houdt zich bezig met
          de bemiddeling tussen de zzp’ er en instellingen die behoefte hebben
          aan een flexibele inzet van uren en het uitzenden en detacheren van
          zorgprofessionals. Tezamen zijn wij verantwoordelijk voor de
          verwerkingen van jouw persoonsgegevens (Verwerkingsverantwoordelijke
          in de zin van de AVG).
          <br />
          <br />
          Uitgangspunt bij het verwerken van gegevens
          <br />
          <br />
          Uitganspunt bij het verwerken van gegevens is dat dit gebeurt:
          <br />
          <ul style={{ marginLeft: "20px" }}>
            <li>met jouw toestemming;</li>
            <li>
              om de overeenkomst en/of gebruikersvoorwaarden die we met je zijn
              overeengekomen goed uit te kunnen voeren
            </li>
          </ul>
          Van wie verzamelen wij persoonsgegevens?
          <br />
          <br />
          Bezoekers en gebruikers van de website of portalen.
          <br />
          <br />
          Welke gegevens worden verzameld:
          <br />
          <br />
          Bij bezoek: Over het algemeen kan onze website en/of portalen bezocht
          worden zonder dat jouw persoonsgegevens aan ons worden doorgegeven.
          Wij verzamelen niet-identificeerbare informatie over gebruikers van de
          website en/of portalen zoals bijvoorbeeld datum en tijd van toegang,
          de bron vanwaar je rechtstreeks bent doorgelinkt naar onze website,
          het besturingssysteem dat je gebruikt, de onderdelen van de website
          en/of portalen die je bezoekt, de pagina’s van de website en/of
          portalen die je hebt bezocht, informatie over het type apparaat dat je
          gebruikt en het materiaal dat je opstuurt of downloadt van de website.
          <br />
          <br />
          Smart-Personeel B.V. maakt tevens gebruik van cookies (1) en
          webstatistieken.
          <br />
          <br />
          Bij gebruik: Zodra je gegevens aan ons verstrekt, door het invullen
          van een formulier, doen van een sollicitatie of inschrijving waarbij
          je een account aanmaakt in ons portaal, verwerken wij die gegevens die
          je aan ons verstrekt. Wij vragen jou om ons enkel informatie te
          verstrekken die correct en relevant is.
          <br />
          <br />
          Doel van verzamelen informatie:
          <br />
          <br />
          Bij bezoek: Deze informatie helpt ons om de website of de app te
          verbeteren, voor jouw gebruiksgemak en om je zo goed mogelijk van
          dienst te zijn.
          <br />
          <br />
          Bij gebruik: om de overeenkomst en/of gebruikersvoorwaarden die we met
          je zijn overeengekomen goed uit te kunnen voeren. Deze gegevens delen
          wij niet via de website maar via een beveiligde mailverbinding Sivver.
          (1) Een cookie is een bestand dat op jouw computer wordt opgeslagen.
          Bij een vervolgbezoek op onze website kunnen deze cookies worden
          herkend. Meer informatie hierover kun je terugvinden verderop in het
          document. Sollicitanten, (potentiële) kandidaten, zzp’ers,
          flexwerkers, medewerkers van leveranciers, deelnemers van klanten of
          andere personen.
          <br />
          <br />
          Smart-Personeel B.V. legt uitsluitend bijzondere persoonsgegevens
          (zoals bedoeld in de Wet Algemene Verordening Gegevensbescherming)
          vast na jouw toestemming.
          <br />
          <br />
          Welke gegevens worden verzameld:
          <br />
          <br />
          We verwerken de persoonsgegevens die noodzakelijk zijn voor onze
          dienstverlening; een deel van deze gegevens is verplicht om gebruik te
          kunnen maken van onze dienstverlening. Zonder deze gegevens kunnen we
          onze dienstverlening niet uitvoeren. Aanvullende gegevens kunnen
          wenselijk zijn om de dienstverlening beter te kunnen afstemmen op jouw
          wensen, kwaliteiten en/of beschikbaarheid of om te voldoen aan meer
          specifieke vragen of verplichtingen ten aanzien van de functie en/of
          vanuit opdrachtgevers. Wij vragen je ons enkel informatie te
          verstrekken die juist en relevant is. We kunnen ook (contact)gegevens
          van je verzamelen indien je deze hebt geplaatst op publieke middelen,
          enkel indien wij een gerechtvaardigde reden hebben om te
          veronderstellen dat je geïnteresseerd zou zijn in werk of onze
          dienstverlening. In dat geval zullen we je benaderen we je om je
          interesse te toetsen om je bij ons in te schrijven conform onze
          voorwaarden en met inachtneming van dit Privacystatement. Je bent zelf
          verantwoordelijk voor persoonlijke gegevens die beschikbaar zijn van
          jou op/via de emial. Tip: check dit regelmatig en indien je niet wil
          dat informatie beschikbaar is voor derden, scherm dit dan goed af.
          <br />
          <br />
          Meer toegelicht gaat per categorie het om, onder andere, de volgende
          (documenten met) persoonsgegevens:
          <br />
          <br />
          Bij inschrijving bij Smart-Personeel B.V:
          <br />
          <ul style={{ marginLeft: "20px" }}>
            <li>
              NAW gegevens, e-mailadres en andere contactgegevens en indien van
              toepassing gegevens over de ZZP onderneming;
            </li>
            <li>geboortegegevens, leeftijd, geslacht;</li>
            <li>
              curriculum vitae (CV), informatie over opleiding, stages en
              werkervaring;
            </li>
            <li>
              gegevens over trainingen en opleidingen en/of testen die jij zelf
              of via ons hebt gevolgd of gedaan;
            </li>
            <li>gegevens over beschikbaarheid en verlof;</li>
            <li>
              andere gegevens die van belang (kunnen) zijn in het kader van de
              beoordeling van de geschiktheid van jou als kandidaat,
              bijvoorbeeld verklaring omtrent gedrag (VOG) referenties en
              getuigschriften;
            </li>
            <li>pasfoto– alleen op vrijwillige basis.</li>
            <li>
              Een kopie van het legitimatiebewijs mag bij de werving en selectie
              worden opgeslagen en gecontroleerd om na te gaan of je mag werken
              in Nederland. Ga je niet binnen vier weken voor ons aan de slag,
              dan wordt het ID-bewijs verwijderd.
            </li>
          </ul>
          Wij spannen ons in voor een inclusieve arbeidsmarkt, waar iedereen die
          kan, mee mag doen. Gegevens zoals jouw geslacht vragen we op om met je
          te communiceren, gegevens over leeftijd om je in onze systemen te
          identificeren.
          <br />
          <br />
          Op het moment dat je kunt gaan werken/werkt/hebt gewerkt voor of via
          Exactzorg B.V.:
          <br />
          <ul style={{ marginLeft: "20px" }}>
            <li>nationaliteit, BSN-nummer, ID bewijs;</li>
            <li>
              overige gegevens die gerelateerd zijn aan jouw registratie als
              zzp’er;
            </li>
            <li>
              daarnaast verwerken wij soms, ten behoeve van bepaalde functies,
              gegevens in het kader van de selectie;
            </li>
          </ul>
          Indien je via ons wordt bemiddeld naar een opdrachtgever;
          <br />
          <br />
          • gegevens noodzakelijk in het kader van de beperking van de
          inlenersaansprakelijkheid (zoals NAW, geboortedatum, BSN, soort
          ID-bewijs, nummer en geldigheidsduur, indien aanwezig:
          verblijfsvergunning, A1-verklaring).
          <br />
          <br />
          Smart-Personeel B.V. legt uitsluitend bijzondere persoonsgegevens (2)
          vast als dat nodig is om aan haar wettelijke verplichtingen te
          voldoen, of indien dit anders toegelaten is bij of krachtens de wet.
          <br />
          <br />
          • Met ‘bijzondere persoonsgegevens’ wordt bedoeld; gegevens over ras
          of etnische afkomst, politieke opvattingen, religieuze of
          levensbeschouwelijke godsdienst of levensovertuiging, genetische en
          biometrische gegevens, gezondheid, seksuele leven, lidmaatschap
          vakbond, strafrechtelijke persoonsgegevens en/of persoonsgegevens over
          onrechtmatig of hinderlijk gedrag.
          <br />
          <br />
          Doel van verzamelen informatie:
          <br />
          <br />
          Wij verzamelen en verwerken jouw gegevens voor de uitvoering van onze
          hr-dienstverlening, waaronder; bemiddeling, planning en facturatie.
          <br />
          <br />
          Meer toegelicht, jouw persoonsgegevens worden verwerkt om;
          <br />
          <ul style={{ marginLeft: "20px" }}>
            <li>(correct en duidelijk) met je te communiceren;</li>
            <li>
              je aanbiedingen te doen en/of informatie te verstrekken over de
              dienstverlening en overige activiteiten en deze beter af te
              stemmen op jouw wensen en kwaliteiten, dit gebeurt door onze
              medewerkers en deels geautomatiseerd via clevergig;
            </li>
            <li>
              je te benaderen voor commerciële aanbiedingen, nieuwsbrieven,
              events en promotie-acties die voor jou interessant kunnen zijn,
              uitsluitend indien je je daarvoor hebt aangemeld;
            </li>
            <li>
              jouw feedback of klachten te verwerken of daarop te reageren om
              onze dienstverlening en middelen te kunnen verbeteren of je beter
              van dienst te kunnen zijn;
            </li>
            <li>onze dienstverlening te verbeteren;</li>
            <li>
              jouw geschiktheid en beschikbaarheid te kunnen beoordelen in
              verband met bemiddeling naar een opdracht, waarbij ook gebruik
              gemaakt kan worden van testresultaten, referentiechecks, social
              media (enkel indien echt relevant is en bij de wervingstekst is
              aangegeven);
            </li>
            <li>
              inzicht te krijgen in bedrijven waar of via wie je mogelijk aan
              gekoppeld kunt worden;
            </li>
            <li>
              je voor te stellen bij onze opdrachtgevers, dit kan ook door
              middel van geluid-en/of beeldmateriaal, in geval van video’s of
              foto’s: uitsluitend indien je deze op vrijwillige basis aan ons
              hebt verstrekt, of hebt laten verstrekken; je zo goed mogelijk
              volgens jouw wensen en beschikbaarheid en de mogelijkheden bij
              onze opdrachtgever in te plannen;
            </li>
            <li>
              een bemiddelingsrelatie met je aan te gaan en te onderhouden en
              hiervoor de relevante (contract)administratie uit te voeren;
            </li>
            <li>
              een opdracht bij de opdrachtgever vast te leggen in een
              overeenkomst met de opdrachtgever en de overeenkomst met de
              opdrachtgever te onderhouden en na te komen;
            </li>
            <li>
              ten behoeve van bepaalde functies gegevens te verwerken in het
              kader van de selectie/screening.
            </li>
            <li>
              jouw persoonlijke ontwikkeling en inzetbaarheid te bevorderen,
              waaronder door training, opleiding en testen;
            </li>
            <li>
              voor management doeleinden waaronder; managementinformatie, het
              verzorgen van interne controles en bedrijfsveiligheid en het
              uitoefenen van audits en accountantscontrole;
            </li>
            <li>kwaliteitsdoeleinden zoals certificering;</li>
            <li>
              aanspraak te kunnen maken op subsidies, premiekortingen,
              loonkostenvoordeel e.d.; als we een bemiddelingsrelatie met je
              zijn aangegaan, voor naleving van wet- en regelgeving, waaronder
              maar niet beperkt tot identificatie, arbeidswetgeving, fiscale- en
              sociale zekerheidswetgeving, pensioen, bestrijding van fraude en
              nationale en internationale sanctiewetgeving.
            </li>
          </ul>
          Zakelijke relaties
          <br />
          <br />
          Welke gegevens worden verzameld:
          <br />
          <br />
          We verwerken de persoonsgegevens die noodzakelijk zijn voor onze
          dienstverlening. Aanvullende gegevens kunnen wenselijk zijn om de
          dienstverlening beter te kunnen afstemmen op jouw wensen, of om te
          voldoen aan meer specifieke vragen of verplichtingen ten aanzien van
          de samenwerking. Wij vragen je ons enkel informatie te verstrekken die
          juist en relevant is. We kunnen ook (contact)gegevens van je
          verzamelen indien je deze hebt geplaatst op publieke middelen, enkel
          indien wij een gerechtvaardigde reden hebben om te veronderstellen dat
          je geïnteresseerd zou zijn in werk of onze dienstverlening. In dat
          geval zullen we je benaderen we je om je interesse te toetsen. Je bent
          zelf verantwoordelijk voor persoonlijke gegevens die beschikbaar zijn
          van jou op/via het internet. Tip: check dit regelmatig en indien je
          niet wil dat informatie beschikbaar is voor derden, scherm dit dan
          goed af.
          <br />
          <br />
          Meer toegelicht gaat het om, onder andere, de volgende (documenten
          met) persoonsgegevens:
          <br />
          <ul style={{ marginLeft: "20px" }}>
            <li>naam en contactgegevens;</li>
            <li>functie;</li>
            <li>
              gegevens van het bedrijf waarvoor je werkt of vertegenwoordigt;
            </li>
            <li>
              gegevens om een goede zakelijke relatie met je kunnen onderhouden;
            </li>
            <li>gegevens ten behoeve van evenementen en bijeenkomsten.</li>
          </ul>
          Doel van verzamelen informatie:
          <br />
          <br />
          voor het doen van aanbiedingen voor en/of verstrekken van informatie
          over de dienstverlening en overige activiteiten en een zakelijke
          relatie te onderhouden en een opdrachtovereenkomst te sluiten en te
          onderhouden.
          <br />
          <br />
          Meer toegelicht, deze persoonsgegevens worden verwerkt om;
          <br />
          <ul style={{ marginLeft: "20px" }}>
            <li>
              de overeenkomst met jou te kunnen vastleggen, onderhouden en na te
              komen;
            </li>
            <li>met jou te kunnen communiceren;</li>
            <li>
              een goede zakelijke relatie met jou te onderhouden, om; je
              aanbiedingen te kunnen doen, relatiegeschenken te verstrekken
              en/of informatie te kunnen verstrekken over de dienstverlening en
              overige activiteiten;
            </li>
            <li>
              je te benaderen voor commerciële aanbiedingen, nieuwsbrieven,
              events en promotie-acties die voor jou interessant kunnen zijn.
            </li>
            <li>om te kunnen factureren;</li>
            <li>om de kredietwaardigheid te kunnen bepalen;</li>
            <li>
              om jou en/of jouw collega’s toegang te verstrekken tot de
              planningsapp en het accountbeheer in te regelen;
            </li>
            <li>
              voor rapportagedoeleinden (bijvoorbeeld om de juiste persoon de
              juiste rapportage te verstrekken);
            </li>
            <li>
              jouw feedback of klachten te verwerken of daarop te reageren om
              onze dienstverlening en middelen te kunnen verbeteren of je beter
              van dienst te kunnen zijn;
            </li>
            <li>onze dienstverlening te verbeteren.</li>
          </ul>
          Wat is de bewaartermijn van je persoonsgegevens?
          <br />
          <br />
          De bewaartermijnen die wij hanteren, zijn afhankelijk van de
          toepasselijke wettelijke bewaartermijnen, eventuele claimrisico’s of
          andere verplichtingen waarbij uitgangspunt is dat jouw
          persoonsgegevens niet langer worden bewaard dan daarvoor noodzakelijk.
          <br />
          <br />
          Kandidaten die (nog) niet voor Exactzorg hebben gewerkt:
          <br />
          <br />
          Jouw bemiddelingsgegevens (CV, werkervaring, opleiding e.d.) zijn
          beschikbaar tot twee jaar na het laatste contact indien je niet voor
          Exactzorg hebt gewerkt. Je krijgt zowel een jaar na het laatste
          contact als twee jaar na het laatste contact een bericht van ons dat
          je bij ons staat ingeschreven. Indien je niet meer bemiddeld wilt
          worden, kun je jezelf uitschrijven door een mail te sturen aan
          info@exactzorg.nl. Je wordt niet meer benaderd en bemiddeld door
          Exactzorg. Jouw persoonsgegevens zijn nog drie kalendermaanden
          beschikbaar in een afgeschermde omgeving. In deze afgeschermde
          omgeving zijn jouw gegevensenkel beschikbaar voor Exactzorg onder
          strikte voorwaarden overeenkomstig de daarvoor gestelde doelen en
          termijnen. Na afloop van genoemde termijnen worden jouw gegevens
          definitief verwijderd. Bij uitschrijving zal je in de toekomst als je
          wilt solliciteren/inschrijven bij Exactzorg opnieuw de procedure
          moeten doorlopen. Indien je nog niet wil dat jouw inschrijving na twee
          jaar wordt verwijderd dan kun je dat voorkomen door: jouw profiel bij
          te laten werken of je beschikbaarheid aan te geven in de clevergigapp.
          Jouw persoonsgegevens zijn enkel beschikbaar voor Exactzorg
          overeenkomstig de daarvoor vastgestelde doelen en termijnen.
          <br />
          <br />
          Kandidaten die voor of via Exactzorg werken/hebben gewerkt:
          <br />
          <br />
          Jouw persoonsgegevens zijn beschikbaar tot twee jaar na einde
          bemiddelingsovereenkomst. Bepaalde persoonsgegevens zijn ten behoeve
          van bijvoorbeeld claims, audits(5 jaar na einde kalenderjaar) en
          fiscale verplichtingen (7 jaar na einde kalenderjaar) langer
          beschikbaar voor Exactzorg.
          <br />
          <br />
          Zakelijke relaties:
          <br />
          <br />
          Persoonsgegevens zijn beschikbaar tot twee jaar na de laatste
          plaatsing.
          <br />
          <br />
          Met wie kunnen wij jouw gegevens delen? Smart-Personeel kan je
          persoonsgegevens doorgeven aan de volgende (categorieën) ontvangers
          voor zover van toepassing;
          <br />
          <ul style={{ marginLeft: "20px" }}>
            <li>
              leveranciers (zoals gegevensverwerkers) die namens Exactzorg
              diensten verlenen of opdrachten uitvoeren. Deze ontvangers hebben
              alleen toegang tot de gegevens die zij nodig hebben om hun taken
              uit te voeren en zijn gebonden aan contractuele verplichtingen;
            </li>
            <li>
              derden zoals dienstverleners die functies in onze opdracht
              uitvoeren (waaronder test-,opleidings, en/of exameninstituten,
              partijen die klanttevredenheidsmetingen doen o.a. ten behoeve van
              keurmerken en certificeringen, externe consultants, zakenpartners
              en professionele adviseurs als advocaten, auditors, technische
              ondersteuningsfuncties en IT-consultants die onze systemen
              ontwikkelen en testen);
            </li>
            <li>
              opdrachtgevers waar we jou voor kunnen stellen, waar je via ons
              aan het werk gaat of bent,;
            </li>
            <li>
              individuen en organisaties die informatie over bijvoorbeeld jouw
              referentie hebben of geschiktheid (zoals diploma’s) of die wij, op
              jouw verzoek, gegevens verstrekken of die ons, op jouw verzoek,
              informatie verstrekken, zoals huidige, voormalige of beoogde
              werkgevers, opleiders, exameninstituten en uitzendbureaus;
            </li>
            <li>
              derden aan wie wij gegevens, met jouw uitdrukkelijke toestemming,
              verstrekken of op jouw verzoek gegevens delen in verband met
              dataportabiliteit;
            </li>
            <li>
              overheidsinstanties en andere instanties indien wij van mening
              zijn dat we daartoe verplicht of gerechtigd zijn.
            </li>
            <li>
              En in alle overige gevallen waarin wij hiertoe worden verplicht,
              bijvoorbeeld door een gerechtelijk bevel of een gerechtelijk
              vonnis.
            </li>
          </ul>
          Het delen van de persoonsgegevens geschiedt op basis van een
          gerechtvaardigd belang, toestemming, wettelijke verplichting en/of ter
          uitvoering van de overeenkomst in overeenstemming met de doelen zoals
          genoemd bij ‘Doel van verzamelen informatie’.
          <br />
          <br />
          Jouw persoonsgegevens kunnen worden doorgegeven of opgeslagen buiten
          Nederland. Smart heeft de nodige maatregelen genomen om te verzekeren
          dat de doorgegeven persoonsgegevens adequaat worden beschermd. Jouw
          persoonsgegevens kunnen worden verstuurd naar een of meerdere landen
          binnen of buiten de Europese Unie en daar worden verwerkt. Wij zullen
          jouw persoonsgegevens alleen naar landen buiten de EU doorgeven
          waarvan de Europese Commissie van mening is dat jij daar een afdoende
          mate van bescherming hebt of waar Smart of haar verwante organisaties
          passende veiligheidsmaatregelen heeft genomen om de privacy van jouw
          gegevens te waarborgen.
          <br />
          <br />
          Jouw rechten
          <br />
          <br />
          Je hebt het recht om een verzoek in te dienen voor:
          <br />
          <ul style={{ marginLeft: "20px" }}>
            <li>inzage in de persoonsgegevens die wij van jou verwerken;</li>
            <li>rectificatie van je persoonsgegevens;</li>
            <li>
              verwijdering van je persoonsgegevens of beperking van verwerking:
              in bepaalde omstandigheden, tenzij wij een goede reden, zoals een
              wettelijke verplichting, hebben om de persoonsgegevens te
              verwerken of niet te verwijderen;
            </li>
            <li>
              beperking van of een bezwaar over de verwerking van de
              persoonsgegevens;
            </li>
            <li>overdracht van je gegevens.</li>
          </ul>
          In geval van jouw verzoek, ter bescherming van de persoonsgegevens,
          zullen wij jouw identiteit moeten kunnen vaststellen. Wij maken geen
          gebruik van geautomatiseerde besluitvorming dat enkel gebaseerd is op
          geautomatiseerde verwerking met inbegrip van profilering.
          <br />
          <br />
          Voor kandidaten, zzp’ers en opdrachtgevers met een account in één van
          onze portalen:
          <br />
          <br />
          • als het verwerken van jouw persoonsgegevens is gebaseerd op jouw
          toestemming, heb je ook het recht om jouw toestemming, op enig moment,
          in te trekken. Het intrekken van jouw toestemming is echter niet van
          invloed op de rechtmatigheid van enige verwerking op basis van jouw
          eerdere toestemming, voordat wij een dergelijke intrekking hebben
          ontvangen of in het geval verdere verwerking van diezelfde gegevens
          volgens een andere grondslag is voortgezet, zoals een overeenkomst of
          wettelijke verplichting van Exactzorg.
          <br />
          <br />
          Hieronder de wijze waarop je je toestemming kunt intrekken;
          <br />
          <br />
          <ul style={{ marginLeft: "20px" }}>
            <li>
              als je je hebt opgegeven voor het ontvangen van informatie voor
              nieuwsberichten, evenementen, alerts of andere berichten, dan kun
              je je daarvoor afmelden via de mail info@smart-personeel.nl;
            </li>
            <li>
              je kunt via je browser settings voorkomen dat cookies worden
              geplaatst maar ook kun je te allen tijde jouw cookie instellingen
              wijzigen of verwijderen van jouw apparaat via de browser
              instellingen;
            </li>
            <li>
              wil je gegevens wijzigen of verwijderen die je zelf niet kunt
              aanpassen, dan kun je opnemen met jouw contactpersoon binnen
              Smart.
            </li>
          </ul>
          Vragen, opmerkingen, klachten of (vermoeden) datalek
          <br />
          <br />
          Heb je vragen, neem dan contact op met (jouw contactpersoon binnen)
          Exactzorg of stuur ons een e-mail. Indien je klachten hebt dan horen
          we dat graag, zodat we je verder kunnen helpen en, zo nodig, onze
          dienstverlening/werkprocessen kunnen aanpassen/verbeteren.
          <br />
          <br />
          Heb je vragen, opmerkingen of klachten over de bescherming van jouw
          persoonsgegevens door Exactzorg, neem dan contact op met de vestiging
          of jouw contactpersoon. Of neem schriftelijk contact op met onze
          functionaris voor gegevensbescherming via Smart t.a.v. functionaris
          gegevensbescherming, via info@smart-personeel.nl Je hebt het recht om
          een klacht in te dienen over de verwerking van jouw persoonsgegevens
          bij de Autoriteit persoonsgegevens. Is er sprake van een (vermoeden
          van) een datalek, bijvoorbeeld, vermoed je verlies of ongeautoriseerde
          toegang tot persoonsgegevens, laat het ons dan direct weten. Wij
          verzoeken je vriendelijk om dit aan ons te melden.
          <br />
          <br />
          Beveiliging
          <br />
          <br />
          Smart doet er alles aan om jouw persoonsgegevens optimaal te
          beschermen. Wij hebben daartoe, rekening houdend met de laatste stand
          van de techniek, fysieke, administratieve, organisatorische en
          technische maatregelen getroffen om onrechtmatig gebruik te voorkomen.
          Deze maatregelen worden regelmatig geëvalueerd en waar nodig
          geactualiseerd.
          <br />
          <br />
          Indien en voor zover gegevens worden verstrekt aan gegevensverwerkers
          die namens haar diensten verlenen of opdrachten uitvoeren, is Smart
          met hen overeengekomen dat zij de persoonsgegevens eveneens optimaal
          beveiligen. Je dient je ervan bewust te zijn dat je zelf
          verantwoordelijk bent voor de beveiliging van jouw computerapparatuur
          en/of telefoon en van jouw eigen internetverbinding, en dat deze nooit
          100% veilig is. De verzending van persoonsgegevens via internet
          geschiedt dan ook op eigen risico. De juiste werking en beveiliging
          van de (web)portalen is alleen van toepassing wanneer het device,
          waarop het portaal geopend wordt voorzien is van de officiële versies
          van besturingssystemen van Google (Android) en Apple (iOS) die door
          ons worden ondersteund.
          <br />
          <br />
          Cookiebeleid
          <br />
          <br />
          Een cookie is een bestand dat op jouw computer wordt opgeslagen. Bij
          een vervolgbezoek op onze website kunnen deze cookies worden herkend.
          Cookies van Smart kunnen je computer of bestanden niet beschadigen.
          Smart plaatst alleen cookies die voor het uitvoeren van de diensten
          noodzakelijk zijn. Indien er andere cookies moeten worden geplaatst,
          dan vragen we jouw voorafgaande toestemming.
          <br />
          <br />
          Onze websites maken gebruik van cookies om de website te helpen
          analyseren hoe gebruikers de website gebruiken. Deze informatie
          bestaat uit: je IP-adres, het type browser, het computersysteem dat je
          gebruikt, accountnummer, de pagina’s die je bezoekt op Exactzorg. De
          verkregen informatie wordt vervolgens gebruikt om de website goed te
          laten werken (ingelogde gebruikers bijhouden, sessie informatie etc.)
          Daarnaast verzamelen wij door middel van cookies informatie over het
          surfgedrag op onze website te verzamelen, wat ook gebruikt wordt om
          onze website te optimaliseren.
          <br />
          <br />
          Smart plaatst geen cookies ten bate van andere partijen, zoals
          advertentie netwerken.
          <br />
          <br />
          De meeste browsers zijn standaard ingesteld om cookies te accepteren,
          maar je kan je browser opnieuw instellen om alle cookies te weigeren
          of om aan te geven wanneer een cookie wordt verzonden. Het is echter
          mogelijk dat sommige functies en services, op onze en op ander
          websites, niet correct functioneren als cookies zijn uitgeschakeld in
          je browser.
          <br />
          <br />
          Wijzigingen
          <br />
          <br />
          Smart kan van tijd tot tijd om uiteenlopende redenen veranderingen,
          aanvullingen of wijzigingen aanbrengen in haar privacystatement. Het
          meest actuele privacystatement is te allen tijde in te zien op de
          website en via in het portaal. We raden je aan het privacystatement
          regelmatig na te lezen. Deze versie is opgesteld in januari 2025.
        </PrivacyResultCard>
      </PrivacyPageTable>

      {/* Privacy: Newsletter */}
      <Newsletter />

      {/* Privacy: Footer */}
      <Footer />
    </PrivacyPageContainer>
  );
}

export default Privacy;
